import { render, staticRenderFns } from "./arrangementManage.vue?vue&type=template&id=d935663e&"
import script from "./arrangementManage.vue?vue&type=script&lang=js&"
export * from "./arrangementManage.vue?vue&type=script&lang=js&"
import style0 from "./arrangementManage.vue?vue&type=style&index=0&id=d935663e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports